import { Component, inject, signal, HostListener } from '@angular/core';
import { ChatService } from '../../../../../services/chat/chat.service';
import { PlayerPanel } from "../../../../../components/users/player-panel/player-panel";
import { VoiceService } from '../../../../../services/voice/voice.service';
import { SettingsService } from '../../../../../services/settings/settings.service';

@Component({
  selector: 'app-player-list',
  imports: [PlayerPanel],
  templateUrl: './player-list.html',
  styleUrl: './player-list.scss',
})
export class PlayerList {
  private chatService = inject(ChatService);
  private voiceService = inject(VoiceService);
  private settingsService = inject(SettingsService);

  public arena = this.chatService.arena;
  public users = this.chatService.users;

  public isMuted = signal(true);
  public isDeafened = signal(false);
  public isPttActive = signal(false);

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.isInputField(document.activeElement)) {
      return;
    }
    if (event.key.toLowerCase() === 'v' && !event.repeat) {
      this.startPtt();
    }
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 'v') {
      this.stopPtt();
    }
  }

  @HostListener('window:blur')
  handleWindowBlur() {
    this.stopPtt();
  }

  private isInputField(element: Element | null): boolean {
    if (!element) return false;
    const tagName = element.tagName.toLowerCase();
    return tagName === 'input' || tagName === 'textarea' || (element as HTMLElement).isContentEditable;
  }

  startPtt() {
    if (this.isDeafened()) return;
    if (this.isMuted()) {
      this.isPttActive.set(true);
      this.voiceService.startTalking();
      this.isMuted.set(false);
    }
  }

  stopPtt() {
    if (this.isPttActive()) {
      this.isPttActive.set(false);
      this.voiceService.stopTalking();
      this.isMuted.set(true);
    }
  }

  toggleMute() {
    if (this.isDeafened()) {
      return; // Cannot unmute while deafened
    }

    this.isPttActive.set(false);

    if (this.isMuted())
      this.voiceService.startTalking();
    else
      this.voiceService.stopTalking();

    this.isMuted.update(m => !m);
  }

  toggleDeafen() {
    this.isDeafened.update(d => !d);
    if (this.isDeafened()) {
      this.isPttActive.set(false);
      this.voiceService.stopTalking();
      this.isMuted.set(true);
    }
  }

  goToSettings() {
    this.settingsService.activeTab.set('audio');
  }
}
